/**
 * Platform fee info. The server is the source of truth — the API reads
 * STRIPE_PLATFORM_FEE_PERCENT and serves it via GET /api/stripe/platform-fee
 * (see usePlatformFee). The constants here are display-only fallbacks used
 * while that fetch is in flight or if it fails; they never feed a charge.
 */

export const DEFAULT_PLATFORM_FEE_PERCENT = 10;

export const PLATFORM_FEE_WAIVER_LABEL = 'Friend of Rich - platform fee waived';

export interface PlatformFeeInfo {
  feePercent: number;
  platformFeeWaived: boolean;
  waiverLabel: string;
}

export const DEFAULT_PLATFORM_FEE_INFO: PlatformFeeInfo = {
  feePercent: DEFAULT_PLATFORM_FEE_PERCENT,
  platformFeeWaived: false,
  waiverLabel: PLATFORM_FEE_WAIVER_LABEL,
};

/**
 * Parse a /api/stripe/platform-fee payload, falling back per-field to the
 * display defaults when a field is missing or malformed.
 */
export function resolvePlatformFeeInfo(data: unknown): PlatformFeeInfo {
  const partial = (data ?? {}) as Partial<PlatformFeeInfo>;
  return {
    feePercent: typeof partial.feePercent === 'number' && Number.isFinite(partial.feePercent)
      ? partial.feePercent
      : DEFAULT_PLATFORM_FEE_PERCENT,
    platformFeeWaived: Boolean(partial.platformFeeWaived),
    waiverLabel: partial.waiverLabel || PLATFORM_FEE_WAIVER_LABEL,
  };
}
